<template>
    <div id="app">
        <router-view />
        <!-- <div style="width: 100vw;height: 100vh;display: flex;align-items: center;justify-content: center;">
            <van-button type="info" @click="openEnterpriseChat">打开会话</van-button>
            <van-button type="info" @click="getCustomerId">客户详情</van-button>
        </div> -->

    </div>
</template>

<script>
import qs from 'qs'
import { getWxConf, getCorpId } from '@/utils/wx'
import { mapGetters } from 'vuex'
// import { AES_ECB_ENCRYPT } from '@/utils/aes'
// 改进后的事件监听
window.onload = function() {
    document.addEventListener(
        'touchstart',
        function(event) {
            if (event.touches.length > 1) {
                event.preventDefault()
            }
        },
        {
            passive: false // 关闭被动监听
        }
    )
    let lastTouchEnd = 0
    document.addEventListener(
        'touchend',
        function(event) {
            const now = new Date().getTime()
            if (now - lastTouchEnd <= 300) {
                event.preventDefault()
            }
            lastTouchEnd = now
        },
        false
    )
}

export default {
    name: 'App',
    data() {
        return {
            code: ''
        }
    },
    beforeCreate() {

    },
    created() {
        console.log('初始化')
        // this.setData() // 本地开发模拟数据(调试打开)
        if (typeof window.entryUrl === 'undefined' || window.entryUrl === '') {
            window.entryUrl = location.href.split('#')[0]
        }
        // if (!this.code) {
        //     this.getCode()
        // }
        getCorpId().then(() => {
            // if (!this.code) {
            //     this.getCode()
            // }
            this.getCode()
        }).catch(error => {
            console.error('初始化失败:', error)
        })
    },
    computed: {
        ...mapGetters(['corpId'])
    },
    methods: {
        // 打开会话
        async openEnterpriseChat() {
            $wx.openEnterpriseChat({
                groupName      : '测试讨论组', // 会话名称。单聊时该参数传入空字符串""即可。
                userIds        : 'zhangsan;lisi;wangwu', // 参与会话的企业成员列表，格式为userid1;userid2;...，用分号隔开。
                externalUserIds: '', // 参与会话的外部联系人列表，格式为userId1;userId2;…，用分号隔开。
                // chatId: "CHATID", // 若要打开已有会话，需指定此参数。如果是新建会话，chatId必须为空串
                success        : function(res) {
                    // const chatId = res.chatId // 返回当前群聊ID，仅当使用agentConfig注入该接口权限时才返回chatId
                    // 回调
                },
                fail: function(res) {
                    console.log('失败', res)
                    if (res.errMsg.indexOf('function not exist') > -1) {
                        alert('版本过低请升级')
                    }
                }
            })
        },
        setData() {
            this.$ls.set('deviceId', 'HO1s8HysZgpd8-hGMOCSemmYvvzN_h4tH8oA7dJ5aNQ')
            this.$ls.set('userInfo', {
                Authorization: 'f8a3dbf650b4b25f2ebdd4d54fd51d56',
                avatar       : '//wework.qpic.cn/wwpic/808717_zoLXifBXTcqTvP4_1668390095/0',
                company_id   : 2,
                mobile       : '18822754334',
                name         : 'Yu',
                target       : 'ADMIN',
                user_id      : 324
            })
        },
        /**
     * @description: 获取授权code
     * @param {*}
     * @return {*}
     */
        getCode() {
            // 从 window.location.href 中截取 code 并且赋值
            // window.location.href.split('#')[0]
            if (window.location.href.indexOf('state') !== -1) {
                this.code = qs.parse(
                    window.location.href.split('#')[0].split('?')[1]
                ).code
            }
            if (this.code || this.$ls.get('Authorization')) {
                if (this.code && !this.$ls.get('Authorization')) {
                    console.log('调用登录接口')
                    this.handGetUserInfo(this.code)
                } else {
                    console.log('微信授权')
                    getWxConf()
                }
            } else {
                console.log('获取用户授权登陆')
                this.handLogin()
            }
        },
        /**
     * @description: 获取用户授权登陆
     * @param {*}
     * @return {*}
     */
        handLogin() {
            // 重定向地址重定到当前页面，在路径获取 code
            const hrefUrl = window.location.href.split('#')[0] // 去掉 hash，保留完整协议和路径
            const redirectUri = encodeURIComponent(hrefUrl)

            if (this.code === '') {
                console.log(this.corpId, 'this.corpId')
                window.location.replace(
                    `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.corpId}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base&state=h5#wechat_redirect`
                )
            }
        },

        /**
     * @description: 获取用户信息
     * @param {*} code
     * @return {*}
     */
        async   handGetUserInfo(sendCode) {
            // 调用后台接口
            const { data, code } = await $request.postRequest({
                url    : this.$requestUrl.main.getUserInfo,
                headers: {
                    'Device-Id': sendCode
                },
                params: {
                    code: sendCode
                }
            })
            if (code === 2000) {
                console.log('登录接口请求成功', data)
                this.$ls.set('Authorization', data.Authorization)
                this.$ls.set('userInfo', data)
                this.$ls.set('deviceId', sendCode)
                getWxConf()
                return
            }
        }
    }
}
</script>
<style>
body,
html {
  height: 100%;
}
#app {
  height: 100%;
  /* padding:10px; */
}
#app > div {
  height: 100%;
}
</style>
